import React from 'react'
import { Button, Card, CardBody, CardHeader, Col, Container, Row, Table } from 'reactstrap'
import { LoadingSpinner } from './../../components'
import CashMahanService from './../../services/cashMahan/CashMahanService'
import CashMahanStatusBadge from './CashMahanStatusBadge'
import { CashMahanEmpty, CashMahanError } from './CashMahanStates'
import {
  apiErrorMessage,
  displayText,
  extractCollection,
  formatDate,
  formatMoney,
  isForbidden,
  isSuccess,
  personName,
  recordId,
  rtlProps,
  unwrapData
} from './cashMahanUtils'

export default class TechnicianWallet extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      error: '',
      empty: false,
      wallet: null,
      transactions: []
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0)
    this.load()
  }

  componentDidUpdate(prevProps) {
    const prevId = prevProps.match && prevProps.match.params ? prevProps.match.params.fixerId : ''
    const nextId = this.fixerId()
    if (prevId !== nextId) {
      this.load()
    }
  }

  fixerId() {
    return this.props.match && this.props.match.params ? this.props.match.params.fixerId : ''
  }

  load() {
    const fixerId = this.fixerId()
    if (!fixerId) {
      this.setState({ error: 'Missing technician / fixer ID', wallet: null, empty: false })
      return
    }
    this.setState({ loading: true, error: '', empty: false })
    CashMahanService.getTechnicianWallet(fixerId, (res) => {
      if (isForbidden(res)) {
        this.setState({ loading: false })
        this.props.history.push('/403')
        return
      }
      if (!isSuccess(res)) {
        this.setState({ loading: false, error: apiErrorMessage(res), wallet: null, empty: false, transactions: [] })
        return
      }
      const data = unwrapData(res)
      const wallet = data.wallet || data
      let transactions = extractCollection(wallet, 'ledgerTransactions')
      if (!transactions.length) {
        transactions = extractCollection(data, 'ledgerTransactions')
      }
      const hasWallet = !!(wallet && (
        wallet.availableBalance !== undefined
        || wallet.pendingSettlement !== undefined
        || wallet.pendingWithdrawal !== undefined
        || transactions.length
      ))
      this.setState({
        loading: false,
        error: '',
        wallet: hasWallet ? wallet : null,
        transactions,
        empty: !hasWallet
      })
    })
  }

  renderBalanceCard(title, value, color) {
    return (
      <Col md="4" style={{ marginBottom: 16 }}>
        <Card className="text-white shadow" style={{ backgroundColor: color }}>
          <CardBody>
            <div style={{ fontSize: 13, opacity: 0.9 }}>{title}</div>
            <div style={{ fontSize: 26, fontWeight: 'bold', marginTop: 8 }}>{formatMoney(value)}</div>
          </CardBody>
        </Card>
      </Col>
    )
  }

  render() {
    const wallet = this.state.wallet || {}
    const name = personName(wallet.fixer)
    return (
      <div className="app align-items-center">
        <Container>
          <Card>
            <CardHeader className='shadow' style={{ backgroundColor: '#4dbd74', borderWidth: 0, color: '#fff' }}>
              <Row>
                <Col md="8" style={{ display: 'flex', alignItems: 'center' }}>
                  <i className="fa fa-wallet" style={{ fontSize: 20 }}></i>
                  <strong style={{ fontSize: 20, marginLeft: 8 }}>
                    Technician wallet
                    {name !== 'N/A' ? <span style={{ marginLeft: 8, ...rtlProps(name).style }}>({name})</span> : ` #${this.fixerId()}`}
                  </strong>
                </Col>
                <Col md="4" style={{ textAlign: 'right' }}>
                  <Button className='actionsBtn' onClick={() => this.props.history.goBack()}>Back</Button>
                  <Button className='actionsBtn' onClick={() => this.load()}>Refresh</Button>
                </Col>
              </Row>
            </CardHeader>
          </Card>

          {this.state.error ? (
            <CashMahanError message={this.state.error} onRetry={() => this.load()} />
          ) : this.state.empty ? (
            <Card>
              <CashMahanEmpty message="No wallet data is available for this technician" onRetry={() => this.load()} />
            </Card>
          ) : (
            <div>
              <Row>
                {this.renderBalanceCard('Available balance', wallet.availableBalance, '#4dbd74')}
                {this.renderBalanceCard('Pending settlement', wallet.pendingSettlement, '#f0ad4e')}
                {this.renderBalanceCard('Pending withdrawal', wallet.pendingWithdrawal, '#20a8d8')}
              </Row>
              <Card>
                <CardHeader className='shadow'>
                  <i className="fa fa-align-justify"></i>
                  <span style={{ marginLeft: 6 }}>Ledger transactions</span>
                </CardHeader>
                {!this.state.transactions.length ? (
                  <CashMahanEmpty message="There's no ledger transaction" />
                ) : (
                  <CardBody className='shadow'>
                    <Table hover bordered striped responsive size="md">
                      <thead>
                        <tr>
                          <th style={{ textAlign: 'center' }}>Date</th>
                          <th style={{ textAlign: 'center' }}>Type</th>
                          <th style={{ textAlign: 'center' }}>Reference</th>
                          <th style={{ textAlign: 'center' }}>Amount</th>
                          <th style={{ textAlign: 'center' }}>Balance after</th>
                          <th style={{ textAlign: 'center' }}>Status</th>
                          <th style={{ textAlign: 'center' }}>Note</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.transactions.map((item, index) => (
                          <tr key={recordId(item) || index}>
                            <td style={{ textAlign: 'center' }}>{formatDate(item.createdAt)}</td>
                            <td style={{ textAlign: 'center' }}>{displayText(item.type)}</td>
                            <td style={{ textAlign: 'center' }}>{displayText(item.reference)}</td>
                            <td style={{ textAlign: 'center' }}>{formatMoney(item.amount)}</td>
                            <td style={{ textAlign: 'center' }}>{formatMoney(item.balanceAfter)}</td>
                            <td style={{ textAlign: 'center' }}><CashMahanStatusBadge item={item} /></td>
                            <td style={{ textAlign: 'center', ...rtlProps(item.note).style }}>
                              {displayText(item.note)}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </CardBody>
                )}
              </Card>
            </div>
          )}
          <LoadingSpinner loading={this.state.loading} />
        </Container>
      </div>
    )
  }
}
